import React, { useEffect, useRef, useState } from "react";

const LeadCards = (props) => {
  const PERSONA = props?.$store?.persona;
  const infoForm = useRef(null);
  const [overallPortfolioData, setOverallPortfolioData] = useState({});
  const [overallmetrics, setOverallmetrics] = useState({});
  const [timeline, setTimeline] = useState("TODAY");

  // OVERALL PORTFOLIO

  const getLeadsOverallMetrics = (query, params) => {
    let data = {
      ...query,
    };

    let payload = {};
    if (params) {
      payload = {
        timeline: params,
      };
    } else {
      payload = {
        timeline: timeline,
      };
    }
    if (PERSONA === _enum.ROUTE_PERSONAS.admin) {
      props.apis.apiGetLeadsByStatus(payload).then(({ data, total }) => {
        let cards = {
          totalLeadsCount: total,
          openCount: data.filter((v) => v.status === "OPEN")[0]?.count,
          interestedCount: data.filter((v) => v.status === "INTERESTED")[0]
            ?.count,
        };
        setOverallmetrics(cards);
      });
    }
    if (PERSONA === _enum.ROUTE_PERSONAS.telecaller) {
      props.apis.apiGetLeadsByStatus(payload).then(({ data, total }) => {
        let cards = {
          totalLeadsCount: total,
          openCount: data.filter((v) => v.status === "OPEN")[0]?.count,
          interestedCount: data.filter((v) => v.status === "INTERESTED")[0]
            ?.count,
        };
        setOverallmetrics(cards);
      });
    }
    if (PERSONA === _enum.ROUTE_PERSONAS.ops) {
      props.apis
        .apiGetLeadsAssignedByCounts(payload)
        .then(({ data, total }) => {
          let cards = {
            totalLeadsCount: total,
            openCount: data.filter((v) => v.status === "OPEN")[0]?.count,
            interestedCount: data.filter((v) => v.status === "INTERESTED")[0]
              ?.count,
          };
          setOverallmetrics(cards);
        });
    }
  };

  const showInputs = (inputnames) => {
    if (inputnames.length > 0) {
      inputnames.forEach((id) => {
        const element = document.getElementById(id);
        if (element) {
          element.classList.remove("d-none");
        }
      });
    }
  };

  const hideInputs = (inputnames) => {
    if (inputnames.length > 0) {
      inputnames.forEach((id) => {
        const element = document.getElementById(id);
        if (element) {
          element.classList.add("d-none");
        }
      });
    }
  };

  const handleDateChange = (value) => {
    let val = value[0]?.key || "TODAY";
    let inputs = [
      "column-start_date",
      "column-end_date",
      "column-search_btn",
      "column-reset_btn",
    ];
    if (val === "CUSTOM") {
      showInputs(inputs);
      setOverallPortfolioData({});
    } else {
      setTimeline(val);
      hideInputs(inputs);
    }
  };

  const onSearch = () => {
    let data = infoForm.current.form.current.getData();
    let queryData = {
      start_date: new Date(data?.start_date).toISOString(),
      end_date: new Date(data?.end_date).toISOString(),
    };
    getLeadsOverallMetrics(queryData, "CUSTOM");
  };

  const resetSearchForm = () => {
    infoForm?.current?.form?.current?.reset();
    let inputs = [
      "column-start_date",
      "column-end_date",
      "column-search_btn",
      "column-reset_btn",
    ];
    hideInputs(inputs);
    getLeadsOverallMetrics({}, "TODAY");
  };

  useEffect(() => {
    getLeadsOverallMetrics();
  }, [timeline, props?.isLeadAdded === true]);

  props.$setNode({
    props,
    overallPortfolioData,
  });

  return (
    <>
      <div className="dashboard_card_container mb-4">
        <div className="metrics_card_row gcol-lg-3">
          <div className="leads_detail_select_box floating_box">
            <AppForm
              ref={infoForm}
              onSubmit={(...args) => onSearch(...args)}
              className="row justify-content-end"
            >
              <div
                className="col-12 col-md-3 col-lg-3 col-xl-2"
                id="column-timeline"
              >
                <AppInputFocus
                  type="select"
                  name="timeline"
                  label="Time Line"
                  options={_enum.OVERALL_DETAIL}
                  onChange={(...args) => handleDateChange(...args)}
                  defaultValue={"TODAY"}
                  placeholder="Time Line"
                  outerclass="mb-0"
                ></AppInputFocus>
              </div>
              <div
                className="col-12 col-md-3 col-lg-3 col-xl-2 d-none"
                id="column-start_date"
              >
                <AppInputFocus
                  type="date"
                  name="start_date"
                  label="Start Date"
                  placeholder="Start Date"
                  outerclass="mb-0"
                  required={true}
                ></AppInputFocus>
              </div>
              <div
                className="col-12 col-md-3 col-lg-3 col-xl-2 d-none"
                id="column-end_date"
              >
                <AppInputFocus
                  type="date"
                  name="end_date"
                  label="End Date"
                  placeholder="End Date"
                  outerclass="mb-0"
                  required={true}
                ></AppInputFocus>
              </div>
              <div
                className="col-2 col-md-1 col-lg-1 col-xl-1 d-none"
                id="column-search_btn"
              >
                <button type="submit" className="btn search_btn white_variant">
                  <i className="fa fa-search"></i>
                </button>
              </div>
              <div
                className="col-2 col-md-1 col-lg-1 col-xl-1 d-none"
                id="column-reset_btn"
              >
                <button
                  type="button"
                  className="btn search_btn white_variant"
                  onClick={(...args) => resetSearchForm(...args)}
                >
                  <i class="fa-solid fa-filter-circle-xmark"></i>
                </button>
              </div>
            </AppForm>
          </div>
          <div className="metrics_card">
            <div className="col_left">
              <img
                src={imagepaths.personPinkIcon}
                className="lead_card_img"
                alt="card icon"
              />
            </div>
            <div className="col_right">
              <h5 className="card-title">{overallmetrics?.totalLeadsCount}</h5>
              <div className="bottom_content">
                <p className="card-text">
                  <span>Total Leads</span>
                </p>
              </div>
            </div>
          </div>
          <div className="metrics_card">
            <div className="col_left">
              <img
                src={imagepaths.personCheckBlueIcon}
                className="lead_card_img"
                alt="card icon"
              />
            </div>
            <div className="col_right">
              <h5 className="card-title">{overallmetrics?.openCount}</h5>
              <div className="bottom_content">
                <p className="card-text">
                  <span className="me-2">Open Leads</span>
                </p>
              </div>
            </div>
          </div>
          <div className="metrics_card">
            <div className="col_left">
              <img
                src={imagepaths.walletTealIcon}
                className="lead_card_img"
                alt="card icon"
              />
            </div>
            <div className="col_right">
              <h5 className="card-title">{overallmetrics?.interestedCount}</h5>
              <div className="bottom_content">
                <p className="card-text">
                  <span className="me-2">Interested Leads</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default constore(LeadCards);
